<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page container" v-else-if="loaded" >
        
        <div class="mt-3 d-none" >
            <ul class="horizontal-menu " > 
                <li>  <router-link :to="{name: 'Integrations'}" class="not-active pl-0" > <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back </router-link>  </li>
            </ul>
        </div>
        
        <div class="row position-relative mt-3" >
            
            <span v-if="editable" class="position-absolute right-0 mt-2 mr-4" >
                <b-button @click="update" variant="primary" class="btn btn-sm" > <font-awesome-icon :icon="['far', 'save']" class="mr-1" />  Save </b-button>    
                <b-button @click="edit" v-if="type == 'edit'" variant="outline-secondary" class="btn btn-sm" > <font-awesome-icon :icon="['fa', 'times']" class="mr-1" />  Cancel </b-button>    
            </span>
            
            <b-dropdown v-if="type == 'edit' && !editable " size="sm" html='Actions <svg aria-hidden="true" class="atlass-icon icon-chevron-down fill-white" height="14" width="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.591 5.293a1 1 0 0 1 1.416 1.416l-6.3 6.3a1 1 0 0 1-1.414 0l-6.3-6.3A1 1 0 0 1 2.41 5.293L8 10.884z" fill-rule="evenodd"></path></svg>' variant="primary" right split-variant class="font-size-14 position-absolute right-0 mt-2 mr-4">
                 <b-dropdown-item-button @click="edit"  >Edit</b-dropdown-item-button>
                <b-dropdown-item-button v-if="data.Status" @click="toggleSwitch( 'Status', false )"   >Deactivate</b-dropdown-item-button>
                <b-dropdown-item-button v-else-if="!data.Status" @click="toggleSwitch( 'Status', true )"  >Activate</b-dropdown-item-button>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button variant="danger" @click="preventDelete()" >Delete</b-dropdown-item-button>
            </b-dropdown>
            
            <div class="col-12 text-center" v-if="type == 'add' "  >

                <div v-if="!integrating"  class="col-12 mt-5" >
                    <div class="text-center font-weight-bold h1 pt-5" > Connect to your Shopify account </div>
                    
                    <div class="text-texter mt-4 mb-2"> 
                        Follow the instructions inside this <a href="https://theatlass.com/resources/shopify-integration-custom-app" target="_blank" class="inline-link font-weight-bold" >doc</a> to generate the access token then come back and set up the integration
                    </div>
                    
                    <div class="text-center font-weight-bold pt-5" >
                        <b-form-input v-model="data.Store" @blur="urlCheck()" placeholder="Enter your store URL" class="search-input atlass-input-borderless" />
                    </div>
                    
                    <div class="text-center font-weight-bold pt-5" >
                        <b-form-input v-model="data.access_token" placeholder="Enter the access token for the custom app" class="search-input atlass-input-borderless" />
                    </div>
                    
                    <div class="text-center font-weight-bold pt-5" >
                        <b-form-input v-model="data.app_secret" placeholder="Enter the API secret key for the custom app" class="search-input atlass-input-borderless" />
                    </div>
                    
                    <div class="text-center font-weight-bold h1 pt-5" >
                        <button 
                            type="button" 
                            class="btn btn-primary d-inline-block" 
                            @click="saveIntegration()"
                        >
                            Connect
                        </button>
                    </div>
                    
                        
                </div>
                
                <div v-else-if="integrating"  class="col-12 mt-4" >
                    <p class="text-center font-weight-bold" > Setting everything up. Might take a while... </p>
                    <spinner type="small" ></spinner>
                </div>
                
                
            </div>
            
            <b-card no-body class="col-12  atlass-tabs" v-if="type == 'edit' " >
                <b-tabs card  >
                    
                    <b-tab @click="goBack" class="p-0" >
                        <template #title>
                            <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back
                        </template>
                    </b-tab>
                    
                    <b-tab title="Overview" class="p-0 " active>
                        <b-card-text>
                            
                            <spinner v-if="!tabloaded" ></spinner>
                            
                            <div v-if="tabloaded"  >
                            <!--  OVERVIEW TAB-->
                                
                                <b-form  class="atlass-form col-12 mt-3 " >
                                    <!-- 
                                    <div class="col-12 border-bottom-gray pb-2 mb-3 d-none" >
                                        <span class="d-inline-block line-height-31" > <h2 class="h2 font-weight-bold line-height-31" > Integration details </h2> </span>
                                        <span class="d-inline-block float-right" > 

                                            <span v-if="data.last_update" class="font-300 font-size-14 line-height-31 mr-2" > Last updated at: <b > {{formatData(data.last_update)}} </b> </span>

                                            <b-dropdown v-if="!editable"  size="sm" html='Actions <svg aria-hidden="true" class="atlass-icon icon-chevron-down fill-white" height="14" width="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.591 5.293a1 1 0 0 1 1.416 1.416l-6.3 6.3a1 1 0 0 1-1.414 0l-6.3-6.3A1 1 0 0 1 2.41 5.293L8 10.884z" fill-rule="evenodd"></path></svg>' variant="primary" right split-variant class="font-size-14">
                                                <b-dropdown-item-button @click="edit"  >Edit</b-dropdown-item-button>
                                                <b-dropdown-item-button v-if="data.Status" @click="toggleSwitch( 'Status', false )"   >Deactivate</b-dropdown-item-button>
                                                <b-dropdown-item-button v-else-if="!data.Status" @click="toggleSwitch( 'Status', true )"  >Activate</b-dropdown-item-button>
                                                <b-dropdown-divider></b-dropdown-divider>
                                                <b-dropdown-item-button variant="danger" @click="preventDelete()" >Delete</b-dropdown-item-button>
                                            </b-dropdown>

                                            <span v-else-if="editable" >
                                                <b-button type="submit" variant="primary" class="btn btn-sm" > <font-awesome-icon :icon="['far', 'save']" class="mr-1" />  Save </b-button>    
                                                <b-button @click="edit" v-if="type == 'edit'" variant="outline-secondary" class="btn btn-sm" > <font-awesome-icon :icon="['fa', 'times']" class="mr-1" />  Cancel </b-button>    
                                            </span>
                                        </span>
                                    </div>
                                    -->
                                    
                                     <div class="col-12 form-group" >
                                         <b-form-group >
                                            <label> Integration Name: </label>
                                            <span v-if="!editable"  class="font-weight-bold" > {{data.Name}} </span>
                                             <b-input-group v-else-if="editable" >
                                                <b-form-input  id="apiKeyInput"
                                                type="text"
                                                v-model="data.Name"
                                                required
                                                placeholder="Shopify Integration">
                                                </b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </div>

                                     <div class="col-12 form-group" >
                                         <b-form-group >
                                            <label> Integration Tag: </label>
                                            <span v-if="!editable" class="font-weight-bold" > !{{data.Tag}} </span>
                                            <b-input-group v-else-if="editable" >
                                                <b-input-group-prepend is-text>  !</b-input-group-prepend>
                                                <b-form-input  id="apiKeyInput"
                                                type="text"
                                                v-model="data.Tag"
                                                required
                                                placeholder="shopify">
                                                </b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </div>

                                     <div class="col-12 form-group" >
                                         <b-form-group >
                                            <label> Store URL: </label>
                                            <span class="font-weight-bold" > {{data.Store}} </span>
                                        </b-form-group>
                                    </div>

                                     <div class="col-12 form-group" >
                                         <b-form-group >
                                            <label> Access Token: </label>
                                            <span v-if="!editable" class="font-weight-bold" > {{data.access_token}} </span>
                                            <b-form-input v-else-if="editable" id="apiKeyInput"
                                            type="text"
                                            v-model="data.access_token"
                                            required
                                            placeholder="shpat_xxxxxxxxxxxxxxx">
                                            </b-form-input>
                                        </b-form-group>
                                    </div>

                                     <div class="col-12 form-group" >
                                         <b-form-group >
                                            <label> API Secret Key: </label>
                                            <span v-if="!editable" class="font-weight-bold" > {{data.app_secret}} </span>
                                            <b-form-input v-else-if="editable" id="apiKeyInput"
                                            type="text"
                                            v-model="data.app_secret"
                                            required
                                            placeholder="xxxxxxxxxxxxx">
                                            </b-form-input>
                                        </b-form-group>
                                    </div>

                                    <div class="col-12 form-group" v-if="ID != 'new'" >
                                         <b-form-group >
                                            <label> Status: </label>
                                            <span v-if="!editable" >
                                                <b v-if="data.Status == 1" > Active </b>
                                                <b v-else-if="data.Status == 0"  > Inactive </b>
                                            </span>

                                            <div v-else-if="editable" >
                                                <b-form-checkbox v-model="data.Status" name="check-button" class="cursor-pointer d-inline-block" switch > </b-form-checkbox>
                                                <span v-if="data.Status" > Active </span>
                                                <span v-else-if="!data.Status" > Inactive </span>
                                            </div>

                                        </b-form-group>
                                    </div>

                                </b-form>

                                <div class="col-12" >

                                    <div class="col-12 border-bottom-gray pb-2 mb-4" >
                                        <span class="d-inline-block line-height-31" > <h2 class="h2 font-weight-bold line-height-31" > Actions </h2> </span>
                                    </div>

                                    <div class="col-12 mt-5" >
                                        <div class="row" >
                                            <div class="col-12 col-md-10" >
                                                <h2 class="h3 font-weight-bold line-height-31" > Webhooks <font-awesome-icon :icon="['fas', 'check-circle']" v-if="data.webhooks" class="font-size-16 color-green" />   </h2>
                                                <div class="mt-1" v-if="data.webhooks" >
                                                    Webhooks have been successfully created. <a @click="listWebhooks()" > See webhooks </a>
                                                </div>
                                                <div class="mt-1" v-else-if="!data.webhooks" >
                                                    Webhooks were not created successfully. Please create them by clicking the button on the right hand side.
                                                </div>

                                            </div>
                                            <div class="col-12 col-md-2 text-right" >
                                                <b-button v-if="type == 'edit' && !data.webhooks" @click="createWebhooks()" variant="outline-secondary" class="btn btn-sm" > 
                                                    <span v-if="!data.webhooks" > Create webhooks </span> 
                                                    <!-- 
                                                    <span  > Working on it <font-awesome-icon :icon="['fas', 'spinner']" class="fa-spin" /> </span> 
                                                    -->
                                                </b-button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 mt-5" >
                                        <div class="row" >
                                            <div class="col-12" >
                                                <h2 class="h3 font-weight-bold line-height-31" > Tracking </h2>
                                                
                                                <div class="mt-1" v-if="!data.assets_url" >
                                                    
                                                    Something went wrong when creating the assets. Please try re-integrating again and delete this one. If issue persists, please reach out to us.
                                                    
                                                </div>
                                                
                                                <div class="mt-1 col-12 text-center" v-else-if="data.assets_url" >
                                                    
                                                    <div class="text-left mt-2 mb-2" > Copy the script below and paste it inside theme.liquid file ( Online Store -> Actions -> Edit Code -> theme.liquid ) and checkout file ( from Settings -> Checkout under Additional Scripts ) </div>
                                                    
                                                    <pre id="script-tracker" class="prettyprint border-gray mt-2 p-4 border-radius bg-color-graylight grayligher-border">&lt;script src="{{ data.assets_url }}" &gt;&lt;/script&gt;</pre>

                                                    <button class="btn btn-copy" @click="copyScript( 'tracker' )" > Copy <font-awesome-icon icon="copy"  class="cursor-pointer graymedium-color h4" ></font-awesome-icon> </button>
                                                    
                                                </div>

                                            </div>
                                            
                                        </div>
                                    </div>

                                </div>

                            <!--  OVERVIEW TAB-->
                            </div>
                            
                        </b-card-text>
                    </b-tab>
                    
                    <!--
                    <b-tab title="Events"  @click="getAdAccounts()" class="p-0 "  >
                        
                        <spinner v-if="!tabloaded" ></spinner>
                        
                        <div v-if="tabloaded"  >
                            
                            <div class="col-12 border-bottom-gray pb-2 mb-4" >
                                <span class="d-inline-block line-height-31" > <h2 class="h2 line-height-31" > Connected Ad accounts </h2> </span>

                                <button type="button"  class="btn btn-outline-primary btn-sm float-right d-none"   @click="importAdAccounts( )"
                                    v-if=" data.refresh_token != '' "
                                >
                                    Reimport Ad Accounts
                                </button>

                            </div>
                            
                            <div class="col-12" >
                                
                                <div class="row" >
                                    <div class="col-12" >
                                        <b-input-group>
                                            <b-form-input v-model="filter" placeholder="Search Ad Accounts" class="search-input atlass-input-borderless" />
                                            <font-awesome-icon icon="times-circle" @click="filter = ''" class="reset-filter" v-bind:class="{ 'd-none' : !filter }" >Clear</font-awesome-icon>
                                        </b-input-group>
                                    </div>
                                </div>
                                
                                <vue-good-table
                                v-if="AdAccounts.length > 0"
                                :columns="columns"
                                :rows="AdAccounts"
                                styleClass="vgt-table atlass-datatable mb-3"
                                :search-options="{ enabled: true, externalQuery: filter }"
                                :pagination-options="{ 
                                    enabled: true,
                                    perPage: 15,
                                    perPageDropdown: [50, 100],
                                    ropdownAllowAll: true,
                                    nextLabel: 'next',
                                    prevLabel: 'prev',
                                    rowsPerPageLabel: 'Ad accounts per page',
                                    ofLabel: 'of',
                                    pageLabel: 'page', // for 'pages' mode
                                    allLabel: 'All',
                                }"
                                :selectOptions="{
                                    enabled: false,
                                    selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                  }"
                                
                                 >

                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'Status'">
                                        
                                        <b-form-checkbox v-model="props.row.Status" name="check-button" class="cursor-pointer d-inline-block" switch    @change="changeAdAccountStatus(props.row)" > </b-form-checkbox>
                                        <span v-if="props.row.Status" >  </span>
                                        <span v-else-if="!props.row.Status" >  </span>
                                        
                                    </span>
                                    <span v-else-if="props.column.field == 'Ads'">
                                        
                                        <a @click="logout()" class="cursor" > <font-awesome-icon icon="list"  /> </a>
                                        
                                    </span>
                                    <span v-else  >
                                        {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>

                            </vue-good-table>
                                
                            </div>
                            
                        </div>
                        
                    </b-tab>
                    -->

                </b-tabs>
            </b-card>

            
        </div>
       
    </div>
</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import helper from '@/helpers/helpers.js';
    
export default {
    name: 'ADWORDS',
    components:{
        
    },
    props: {
        ID:{
            type: [String]
        }
    },
    data: function(){
        return {
            loaded: false, 
            
            store: "",
            data:{
                "APP": "SHOPIFY",
                Name: "Shopify Integration",
                Tag: "shopify",
                "Type" : 'eccommerce',
                Store: "",
                access_token: '',
                app_secret: '',
                Status: true,
            },
            AdAccounts: [],
            type: 'add',
            editable: false,
            tabloaded: false,
            allowTestIntegration: false,
            integrating: false,
            timeout: 500,
            
            filter: '',
            columns: [
                {
                    label: 'Name',
                    field: 'Name',
                    tdClass: 'font-weight-bold',
                },
                {
                    label: 'ACCOUNT ID',
                    field: 'AccountID',
                    tdClass: 'font-weight-bold',
                },
                /*
                {
                    label: 'ACCOUNT ID',
                    field: 'account_id'
                    //field: this.renderTag
                },
                */
                {
                    label: 'CURRENCY',
                    field: 'Currency',
                },
                {
                    label: 'TIMEZONE',
                    field: 'Timezone',
                },
                {
                    label: 'STATUS',
                    field: 'Status',
                    sortable: false,
                    tdClass: 'text-center',
                    thClass: 'text-center',
                },
                {
                    label: 'ADS',
                    field: 'Ads',
                    sortable: false,
                    tdClass: 'text-center',
                    thClass: 'text-center',
                },
            ],
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        
        //console.log(this.ID)
        if( this.ID == 'new' ){
            this.loaded = true
            this.editable = true
        
            
        }else{
            this.get_data( this.ID );
        }
        
    },
    beforeDestroy() {
    },
    methods: {
        
        Connect( ){
            
            if( this.store != '' ){
                let url = 'https://sql.theatlass.com'
                //url = 'https://192.168.64.4/theatlass.com/sql'
                //window.open(url, '_blank').focus();

                url += '/shopify/install.php?shop='+this.data.store
                
                window.location.replace( url );
            }
            
                
            
            
        },
        
        saveIntegration(){
            
            this.integrating = true
            
            if( this.data.Store == '' && this.data.access_token == '' && this.data.access_token == 'app_secret' ){
                
                this.$toast.error({
                    title:'Error',
                    message: 'Store URL and Access Token are both required'
                })
                
            }else{
                let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
                const db = this.$firebase.firestore();

                let document = this.data
                document.datetime = Math.round(+new Date()/1000)

                if( this.type == 'add' ){

                    document.Name = this.data.Store + " Integration"

                    //document.Store = shop
                    //document.access_token = access_token

                    console.log(document)

                    let ref = this.$firebase.firestore().collection('organizations/'+orgID+'/integrations')

                    return ref.add( document )
                     .then((result)=>{
                        let docID = result.id

                        //console.log(result)
                        //console.log(docID)

                         this.createWebhooks( this.data.access_token, this.data.Store, docID )

                        this.editable = false

                    })

                }
            }
                
            
        },
        
        urlCheck(  ){
            
            this.data.Store = this.getHostName( this.data.Store )
            
        },
        
        getHostName( url ) {
            var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
            if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
                return match[2];
            }else {
                return null;
            }
        },
        
        createWebhooks( access_token = null, shop = null, docID = null ){
            
            let redirect = true
            if( access_token == null ){
                redirect = false;
                shop = this.data.Store
                docID = this.data.docID
                access_token = this.data.access_token
            }
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            let integration_hash = btoa(orgID+"_"+docID)
            
            return axios({ 
                method: 'post',
                //url: 'https://sql.theatlass.com/shopify/webhook_create.php',
                url: 'https://sql.theatlass.com/shopify/setup.php',
                headers: { 
                    'Access-Control-Allow-Headers': '*', 
                    'Access-Control-Allow-Origin': '*',  
                    'Content-Type': 'application/json;' 
                },
                data: { 
                    "access_token": access_token,
                    "shop": shop,
                    "integration": integration_hash,
                } 
            })
            .then(resp => {    
                //console.log(resp)
                if( resp.status == 200 && resp.data.status == 200 ){
                    
                    let ref = this.$firebase.firestore().collection('organizations/'+orgID+'/integrations').doc( docID ) 
                    
                    let updateDoc = {  }
                    if( resp.data.data.webhooks.length > 0 ){
                        updateDoc.webhooks = true
                        this.data.webhooks = true
                    }
                    if( resp.data.data.assets ){
                        updateDoc.assets_url = resp.data.data.assets
                        this.data.assets_url = resp.data.data.assets
                    }
                    ref.update( updateDoc )
                 
                    this.$toast.success({
                        title:'Success',
                        message: 'Webhooks created successfully'
                    })
                    
                }
                
                if( redirect ){
                    this.$router.push({
                        name: 'SHOPIFY',
                        params: { ID: docID }
                    }); 
                    this.get_data(docID)
                }
                
            })
            .catch(error => {
                
                if( redirect ){
                    this.$router.push({
                        name: 'SHOPIFY',
                        params: { ID: docID }
                    }); 
                    this.get_data(docID)
                }
                console.log(error)
                /*
                this.$toast.error({
                    title:'Error',
                    message:  'Error while fetching sources. Please reach out to us!'
                })
                */
            }); //end axios 
            
            
        },
        
        listWebhooks( access_token = null, shop = null, docID = null ){
            
            let redirect = true
            if( access_token == null ){
                redirect = false;
                shop = this.data.Store
                docID = this.data.docID
                access_token = this.data.access_token
            }
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            let integration_hash = btoa(orgID+"_"+docID)
            
            return axios({ 
                method: 'post',
                url: 'https://sql.theatlass.com/shopify/webhook_listAll.php',
                headers: { 
                    'Access-Control-Allow-Headers': '*', 
                    'Access-Control-Allow-Origin': '*',  
                    'Content-Type': 'application/json;' 
                },
                data: { 
                    "access_token": access_token,
                    "shop": shop,
                    "integration": integration_hash,
                } 
            })
            .then(resp => {    
                console.log(resp)
            })
            .catch(error => {
                console.log(error)
            }); //end axios 
            
            
        },
        
        //EDIT
        
        importAdAccounts( docID = null ){
            
            let redirect = true
            if( docID == null ){
                let redirect = false
                docID = this.data.docID
            }
            
            this.getAccessToken( this.data.refresh_token )
            .then((response)=>{
                
                let access_token = response.data.data.access_token
                
                this.getAccessibleCustomers( access_token )
                .then((response)=>{

                    let customers = response.data.data

                    let AdAccounts = this.processCustomers( customers )
                    
                    this.AdAccounts = AdAccounts
                    
                    if( this.AdAccounts.length > 0 ){
                        this.AdAccounts.forEach((document, i)=>{
                            //SAVE
                            document.datetime = Math.round(+new Date()/1000)

                            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
                            let ref = this.$firebase.firestore().collection('organizations/'+orgID+'/integrations/'+docID+'/AdAccounts').add( document )

                            return ref
                            .then((result)=>{

                                if( i == this.AdAccounts.length - 1 ){

                                    if( redirect ){

                                        this.$toast.success({
                                            title:'Success',
                                            message: 'Integration successful'
                                        })   

                                        this.$router.push({
                                            name: 'ADWORDS',
                                            params: { ID: docID }
                                        }); 

                                        this.integrating = false
                                        this.get_data( docID );

                                    }else{
                                        this.$toast.success({
                                            title:'Success',
                                            message: 'Import successful'
                                        }) 
                                        this.integrating = false
                                    }

                                }

                            })
                            //SAVE
                        }) //this.AdAccounts.forEach
                    }else{
                        
                        if( redirect ){

                            this.$toast.success({
                                title:'Success',
                                message: 'Integration successful'
                            })   

                            this.$router.push({
                                name: 'ADWORDS',
                                params: { ID: docID }
                            }); 

                            this.integrating = false
                            this.get_data( docID );

                        }else{
                            this.$toast.success({
                                title:'Success',
                                message: 'Import successful'
                            }) 
                            this.integrating = false
                        }
                        
                    }
                        
                    
                    
                }) //END getAccessibleCustomers
                
            })
                
            
        },
        
        processCustomers( customers ){
            
            let AdAccounts = []
            customers.forEach((customer)=>{
                
                if( !customer.info.error ){
                    
                    if( customer.manager == true ){
                        
                        customer.clients.forEach((client)=>{
                            
                            let obj = {
                                ResourceName: client.customerClient.resourceName,
                                AccountID: client.customerClient.id,
                                Name: client.customerClient.descriptiveName,
                                Currency: client.customerClient.currencyCode,
                                Timezone: client.customerClient.timeZone,
                                Status: true,
                                datetime: Math.round(+new Date()/1000)
                            }
                            
                            if( !client.customerClient.manager ){
                                obj.managedBy = customer.customerID
                            }
                            
                            if( obj.Name == undefined ){
                                obj.Name = "Account "+client.customerClient.id
                            }
                            
                            if( AdAccounts.find(item => item.AccountID === obj.AccountID ) == undefined ){
                                AdAccounts.push( obj )
                            }
                                
                            

                            
                        })
                        
                    }else{
                        
                        let obj = {
                            ResourceName: customer.info.resourceName,
                            AccountID: customer.info.id,
                            Name: customer.info.descriptiveName,
                            Currency: customer.info.currencyCode,
                            Timezone: customer.info.timeZone,
                            Status: true,
                            datetime: Math.round(+new Date()/1000)
                        }
                        
                        if( obj.Name == undefined ){
                            obj.Name = "Account "+customer.info.resourceName
                        }
                        
                        if( AdAccounts.find(item => item.AccountID === obj.AccountID ) == undefined ){
                            AdAccounts.push( obj )
                        }
                    }
                    
                }
                
                        
            })
            
            //console.log( AdAccounts )
            return AdAccounts
            
        },
        
        goBack(){
            this.$router.push({
                name: "Integration",
                params: { APP: 'SHOPIFY' }
            });
        },
        
        get_data( ID ){
          
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = this.$firebase.firestore();
            
            var ref = db.collection('organizations/'+orgID+'/integrations').doc( ID )
                                    
            return ref.get()
                .then((snapshot) => {
                    if( !snapshot.empty ){
                        //console.log(snapshot.data())
                        this.data = snapshot.data()
                        this.data.docID = snapshot.id
                        
                        this.type = 'edit'
                        this.allowTestIntegration = true
                        this.editable = false
                        
                    }else{
                        console.log("No integration set")
                    }
                        
                    this.loaded = true;
                    this.tabloaded = true;
                })
          
        },
        
        getAdAccounts(  ){
            
            this.tabloaded = false
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )            
            var ref = this.$firebase.firestore().collection('organizations/'+orgID+'/integrations/'+this.ID+'/AdAccounts')
                                    
            return ref.get()
            .then((results) => {
                
                this.AdAccounts = [];
                results.forEach((account)=>{
                    this.AdAccounts.push( account.data() )
                })
                this.tabloaded = true
                
            })
            
        },
        
        formatData(unix){
            //console.log(unix)
            return this.$moment.unix(unix).format( 'MMM D YYYY, HH:mm' )
        },
        edit(){
            this.editable = !this.editable
        },
        
        copyScript( type ){
            
            var range = document.createRange();
            range.selectNode(document.getElementById("script-"+type));
            window.getSelection().removeAllRanges(); // clear current selection
            window.getSelection().addRange(range); // to select text
            document.execCommand("copy");
            window.getSelection().removeAllRanges();// to deselect
            
            this.$toast.success({
                title:'Success',
                message:  'Copied to clipboard!'
            })
            
        },
        
        update(){
                        
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            const db = this.$firebase.firestore();
            
            let document = this.data
            document.last_update = Math.round(+new Date()/1000)

            let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.data.docID )

            return ref.set( document, { merge: true } )
            .then((result)=>{

                this.$toast.success({
                    title:'Success',
                    message: 'Changed saved '
                })

                this.editable = false

            })
                

            
        },
        
        testIntegration(){
            let params = Cookies.get('user-token')
            //let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            let data = { "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ), "integrationID": this.data.docID }
            //let data = JSON.stringify( this.newOrg )/
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "X-Auth": params }
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/integrations/mailchimp/test', headers: headers, data: data })
                .then(resp => {
                                
                if( resp.status == 200 ){
                    let r = resp.data;
                    
                    this.$toast.success({
                        title:'Success',
                        message: r.health_status
                    })
                }
                    
                
            }).catch(error => {
                console.log(error)
            }); //end axios 
            
        },
        
        toggleSwitch( field, value ){
            
            let document = {}
            let update = true;
            
            console.log(this.data)
            
            if( field == 'Status' ){
                this.data.Status = value
                document.Status = value
            }else if( field == 'sync_leads' ){
                let settings = {}
                settings.sync_leads = this.data.settings.sync_leads
                document['settings.sync_leads'] = !this.data.settings.sync_leads
                
                if( !this.data.settings.sync_leads ){
                    update = false
                }else{
                    update = true
                }
                
            }else if( field == 'attribute_campaigns' ){
                document['settings.attribute_campaigns'] = !this.data.settings.attribute_campaigns
            }else if( field == 'audience_ID' ){
                if( this.data.audience_ID == '' ){
                    this.data.settings.sync_leads = false
                }
                document['settings.sync_leads'] = this.data.settings.sync_leads
                document.audience_ID = this.data.audience_ID
            }
            
            document.last_update = Math.round(+new Date()/1000)
            
            if( update ){
                //UPDATE FIRESTORE
                let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
                const db = this.$firebase.firestore();
                let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.data.docID )

                return ref.update( document )
                .then((result)=>{
                    this.$toast.success({
                        title:'Success',
                        message: 'Changed saved '
                    })
                })
            }
            
        },//end toggleSwitch
        
        logout(){
            
        },
        
        preventDelete( ){
            
            this.$swal({
                title: 'Are you sure?',
                text: 'This cannot be undone and the conversion will be deleted as well',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) { 
                    
                    this.delete( );
                    
                }
            })
            
        },        
        delete: function( ){
            
            this.loaded = false
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = firebase.firestore();
            
            let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.ID )
            return ref.delete()
            .then(function(){

                //DE:E
                this.deleteWebhooks()
                

            }.bind(this))
            .catch(function(error){

                //console.error("Error updating document: ", error);
                this.$toast.error({
                    title: 'Error',
                    message: "Something went wrong: "+error
                })

                this.loaded = true

            }.bind(this))
            
        },
        
        deleteWebhooks(){
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            let integration_hash = btoa(orgID+"_"+this.data.docID)
            
            return axios({ 
                method: 'post',
                url: 'https://sql.theatlass.com/shopify/uninstall.php',
                headers: { 
                    'Access-Control-Allow-Headers': '*', 
                    'Access-Control-Allow-Origin': '*',  
                    'Content-Type': 'application/json;' 
                },
                data: { 
                    "access_token": this.data.access_token,
                    "shop": this.data.Store,
                    "integration": integration_hash,
                } 
            })
            .then(resp => {    
                //console.log(resp)
                this.$toast.success({
                    title: 'Success',
                    message: 'Integration deleted'
                })

                setTimeout(function(){ 
                    this.loaded = true
                    this.$router.push({
                        name: 'Integrations'
                    }); 
                }.bind(this), this.timeout );

            })
            .catch(error => {
            
                console.log(error)

            }); //end axios 
            
        }
        
    },
    watch: {

    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
    .tab-pane{
        margin-top: 2rem;
    }
    
</style>



// WEBPACK FOOTER //
// src/templates/setup/integrations/SHOPIFY_CUSTOM.vue